export const saveCsv = (header: string, content: string) => {
  const currentDate = new Date();
  const fileName = `json-to-csv-${currentDate.getTime()}.csv`;

  const blobContent = new Blob([header, content], {
    type: "application/csv;charset=utf-8;"
  });

  const linkElement = document.createElement("a");
  const href = URL.createObjectURL(blobContent);
  linkElement.href = href;
  linkElement.download = fileName;
  document.body.appendChild(linkElement);
  linkElement.click();
  document.body.removeChild(linkElement);
};
